import React, { useState } from "react";
import classNames from "classnames";
import brand from "@utils/brand";
import { CardSupporter } from "@molecules";
import { Container, Text, Button } from "@atoms";

const SupporterGrid = ({ heading, copy, supporters }) => {
  const { lgca, lakota } = brand;
  const [visibleSupporters, setVisibleSupporters] = useState(12);
  return (
    <div
      className={classNames("py-12 md:pb-24", {
        "bg-gray-light": lakota,
        "bg-offwhite": lgca,
      })}
    >
      <Container>
        <div className="flex flex-col items-center">
          <Text variant="h3" className="text-center text-red">
            {heading}
          </Text>
          <Text variant="body--large">{copy}</Text>
          <div className="w-full">
            {!!supporters?.length && (
              <ul
                className={classNames(
                  "-mx-3 mt-12 flex flex-wrap items-stretch justify-center",
                  {}
                )}
              >
                {supporters
                  ?.slice(0, visibleSupporters)
                  ?.map((supporter, i) => {
                    return (
                      <>
                        {supporters.slice(0, visibleSupporters).length % 4 ===
                          1 &&
                          i ===
                            supporters.slice(0, visibleSupporters).length -
                              2 && (
                            <li className="hidden w-full opacity-0 sm:block" />
                          )}
                        <li className="mb-6 flex w-1/2 px-3 sm:w-1/4 md:w-1/5">
                          <CardSupporter {...supporter} key={supporter.uid} />
                        </li>
                      </>
                    );
                  })}
              </ul>
            )}
          </div>
          {supporters?.length > visibleSupporters && (
            <div className="mt-6">
              <Button
                onClick={() => {
                  setVisibleSupporters(visibleSupporters + 8);
                }}
              >
                View More
              </Button>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

SupporterGrid.defaultProps = {};

export default SupporterGrid;
